export default __webpack_public_path__ + "static/graphik-semibold-web-fb98917f26ad6d276900cfd1b9c4f923.woff";